import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteUserSlice = createSlice({
    name: "deleteUserRequest",
    initialState,
    reducers: {
        deleteUserRequest(state) {
            state.loading = true;
        },
        deleteUserRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteUserRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteUserStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteUserRequest,
    deleteUserRequestSuccess,
    deleteUserRequestError,
    deleteUserStateReset,
} = DeleteUserSlice.actions;

export default DeleteUserSlice.reducer;
